import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { getSessionTimeoutMinutos, clearSessionUser, getSessionUserId, updateSessionTimeout } from './SessionUser';
import AlertDialog from '../components/Lms/Components/Shared/AlertDialog';
import axios from 'axios';
import { ENDPOINTS } from '../components/Seguridad/Utils/Endpoints';

export const SessionTimeoutHandler = ({ children }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const timerRef = useRef(null);
    const [showTimeoutModal, setShowTimeoutModal] = useState(false);

    // Lista de eventos que resetean el contador
    const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'];

    // Sincronizar timeout desde la BD al montar (proteger contra refresh)
    useEffect(() => {
        const userId = getSessionUserId();
        if (userId) {
            axios.get(ENDPOINTS.configuracionTimeout(userId))
                .then(res => {
                    const newMins = parseFloat(res.data);
                    updateSessionTimeout(newMins);
                    // console.log(`[SessionTimeout] Timeout sincronizado tras refresh: ${newMins} min.`);
                    resetTimer(); // Reiniciar con el nuevo valor
                })
                .catch(err => console.error("[SessionTimeout] Error sincronizando timeout:", err));
        }
    }, []);

    const resetTimer = () => {
        if (timerRef.current) clearTimeout(timerRef.current);

        const timeoutMins = getSessionTimeoutMinutos();
        const timeoutMs = timeoutMins * 60 * 1000;

        // Descomenta este log si quieres ver cada movimiento (es ruidoso)
        // console.log(`[SessionTimeout] Actividad detectada. Reseteando a ${timeoutMins} min.`);

        timerRef.current = setTimeout(() => {
            if (getSessionUserId()) {
                console.warn(`[SessionTimeout] !!! SESIÓN EXPIRADA POR INACTIVIDAD (${timeoutMins} min) !!!`);
                clearSessionUser();
                setShowTimeoutModal(true);
            }
        }, timeoutMs);
    };

    useEffect(() => {
        // console.log("[SessionTimeout] Componente montado o ruta cambiada:", location.pathname);

        const publicPages = ['/login', '/', '/forgot-password', '/reset-password'];
        const isPublic = publicPages.includes(location.pathname);

        if (isPublic) {
            if (timerRef.current) {
                // console.log("[SessionTimeout] Página pública detectada. Monitor detenido.");
                clearTimeout(timerRef.current);
                timerRef.current = null;
            }
            return;
        }

        const userId = getSessionUserId();
        if (userId) {
            const mins = getSessionTimeoutMinutos();
            // console.log(`[SessionTimeout] Iniciando monitor para usuario ${userId}. Expira en ${mins} min de inactividad.`);

            // Forzar el inicio del contador
            resetTimer();

            // Agregar listeners
            events.forEach((event) => {
                window.addEventListener(event, resetTimer);
            });
        } else {
            // console.log("[SessionTimeout] No hay usuario en sesión. Monitor en espera.");
        }

        return () => {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
                timerRef.current = null;
            }
            events.forEach((event) => {
                window.removeEventListener(event, resetTimer);
            });
        };
    }, [location.pathname]);

    const handleConfirmTimeout = () => {
        setShowTimeoutModal(false);
        navigate('/login');
    };

    return (
        <>
            {children}
            <AlertDialog
                open={showTimeoutModal}
                onClose={handleConfirmTimeout}
                title="Sesión Expirada"
                message="Tu sesión ha finalizado por falta de actividad. Por favor, inicia sesión nuevamente para continuar."
                buttonText="Entendido"
                variant="warning"
            />
        </>
    );
};
